module.exports = "<div class=\"app\" ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 677
// module chunks = 0